import React, { memo } from 'react';
import classNames from 'classnames';
import { Button } from 'modules/ui';
import { Icon } from '../Icon';
import styles from './IconButton.module.scss';

function IconButton({
  iconName,
  iconColor,
  iconSize,
  iconClassName,
  className,
  label,
  disabled,
  showActiveIndicator = false,
  isFlippedVertical = false,
  ...otherProps
}) {
  const classes = classNames(
    styles.btn,
    disabled && styles.disabled,
    className,
  );

  return (
    <Button
      small
      type="button"
      className={classes}
      disabled={disabled}
      {...otherProps}
    >
      <Icon
        name={iconName}
        color={iconColor}
        size={iconSize}
        className={iconClassName}
        isFlippedVertical={isFlippedVertical}
      />
      {label}
      {showActiveIndicator && <div className={styles.activeIndicator} />}
    </Button>
  );
}

export default memo(IconButton);
